module.exports = __webpack_public_path__ + "static/media/property.b54de7fd.svg";